<template>
    <!-- 官网首页,登陆页第二个头部 -->
    <div class="indexLoginBottomHead">
        <div class="bottom-head">
            <div class="contain">
                <el-row style="line-height:61px">
                    <el-col :span="7">
                        <div class="head-logo">
                            <img src="../../assets/img/logo7.png" alt />
                        </div>
                    </el-col>
                    <el-col :span="10" class="search">
                        <el-input
                            placeholder="请输入关键词搜索"
                            v-model="seachInput"
                            class="input-with-select head-input"
                            style="width:500px;border:1px solid #f64420"
                        >
                            <template slot="append">
                                <el-button
                                    type="primary"
                                    icon="el-icon-search"
                                    id="searchButton"
                                    @click="search()"
                                >搜索</el-button>
                            </template>
                        </el-input>
                    </el-col>
                </el-row>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "indexLoginBottomHead",
    data() {
        return {
            seachInput: "",
            routers: []
        };
    },
    methods: {
        handleSelect(index) {
            this.activeIndex = index;
        },
        //全局搜索
        search() {
            let that = this;
            that.$router.push({
                path: "/commodity",
                query:{
                    select:that.seachInput
                    }
                });

         }
    },
    created() {
        this.routers = this.$router.options.routes[0].children;
    }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.search{
    margin-left:50px;
}
.bottom-head .is-active {
    color: black;
    border-bottom: 2px solid #f64420;
    border-bottom-color: #f64420;
    background-color: none;
}
.bottom-head .el-menu-item {
    color: #777f8f !important;
}

.head-title {
    font-size: 12px;
    line-height: 40px;
    letter-spacing: 1.9px;
    color: #ffffff;
    opacity: 0.4;
}
.top-head {
    width: 100%;
    height: 40px;
    background-color: #333333;
}
.top-head .el-col,
.top-head .el-row {
    height: 100%;
}
.el-menu-black > .el-menu-item {
    line-height: 40px;
    height: 40px;
    opacity: 0.4;
    font-size: 12px;
}
.el-menu-black {
    line-height: 40px;
    height: 40px;
    float: right;
}
.el-menu-white {
    width: 650px;
    border: none;
    float: right;
}
.bottom-head {
    padding: 20px 0px;
    /* box-shadow: 0px 0px 8px 0px
		rgba(0, 0, 0, 0.12); */
}
.head-logo {
    max-height: 60px;
}
.head-logo img {
    display: block;
    height: 60px;
}
/* header .el-input-group {
  width: 252px;
  margin-top: 15px;
  float: right;
} */
.el-menu.el-menu--horizontal {
    border-bottom: none;
}
</style>



// WEBPACK FOOTER //
// src/components/ShoppingMall/IndexBottom.vue